import { Header } from "./components";
import AdsControls from "./components/AdsControls";
import AdsList from "./components/AdsList";

const Ads = () => {
  return (
    <div>
      <Header />
      <AdsControls />
      <AdsList />
    </div>
  );
};

export default Ads;
